import { render, staticRenderFns } from "./dialog-change-price.vue?vue&type=template&id=e221e6d0&"
import script from "./dialog-change-price.vue?vue&type=script&lang=ts&"
export * from "./dialog-change-price.vue?vue&type=script&lang=ts&"
import style0 from "./dialog-change-price.vue?vue&type=style&index=0&id=e221e6d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports